/**
 * @Author: 71
 * @Date: 2026-08-12 17:19:01
 * @LastEditTime: 2026-08-20 10:20:56
 * @LastEditors: 71
 * @Description: 
 * @FilePath: \aigoes-school-web\src\permission.js
 * @苍天eye有，bug木有~~
 */
import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { generateIndexRouter } from '@/utils/util'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/user/login', '/user/register', '/user/register-result', '/user/alteration', '/user/login-bridge'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  const metaTitle = to?.meta?.title || ''
  NProgress.start() // start progress bar
  if (Vue.ls.get(ACCESS_TOKEN)) {
    document.title = metaTitle
    /* has token */
    if (to.path === '/user/login') {
      // 跳转首页 / 调整到默认第一个页面
      const res = store.dispatch('GetPermissionList').then((res) => {
        const { menu } = res.result
        const defaultPath = menu[0]?.children?.[0]?.path || menu[0]?.path
        // next({ path: INDEX_MAIN_PAGE_PATH })
        next({ path: defaultPath })
        NProgress.done()
      })
    } else {
      if (store.getters.permissionList.length === 0) {
        store
          .dispatch('GetPermissionList')
          .then((res) => {
            const menuData = res.result.menu
            console.log('menuData', menuData)
            //console.log(res.message)
            if (menuData === null || menuData === '' || menuData === undefined) {
              return
            }
            let constRoutes = []
            constRoutes = generateIndexRouter(menuData)
            // 添加主界面路由
            store.dispatch('UpdateAppRouter', { constRoutes }).then(() => {
              // 根据roles权限生成可访问的路由表
              // 动态添加可访问路由表
              router.addRoutes(store.getters.addRouters)
              const redirect = decodeURIComponent(from.query.redirect || to.path)
              if (to.path === redirect) {
                // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                next({ ...to, replace: true })
              } else {
                // 跳转到目的路由
                next({ path: redirect })
              }
            })
          })
          .catch(() => {
            /* notification.error({
              message: '系统提示',
              description: '请求用户信息失败，请重试！'
            })*/
            store.dispatch('Logout').then(() => {
              next({ path: '/user/login', query: { redirect: to.fullPath } })
            })
          })
      } else {
        next()
      }
    }
  } else {
    document.title = metaTitle || '欢迎登录'
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next({ path: '/user/login', query: { redirect: to.fullPath } })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
